<script lang="ts" setup>
import { formatIndicatorTitle, formatIndicatorValue, getComparisonClass } from '#helpers';
import type { Indicator } from '@carrefour-gcs/shared';

defineProps<{
  bars: NonNullable<Indicator['bars']>;
}>();

const BAR_COLORS = ['#173EB4', '#0970E6', '#30A297'];
</script>

<template>
  <div>
    <div v-for="(bar, index) of bars" :key="bar.label" class="grid grid-flow-col grid-cols-7 gap-2 my-2">
      <span class="capitalize col-span-2">{{ bar.label?.toLowerCase() }}</span>

      <div
        v-if="bar.value"
        class="w-full bg-background-main-secondary border border-border-main-primary rounded-r col-span-3"
      >
        <div
          class="h-full rounded-r"
          :style="{
            width: `${bar.value.value}%`,
            'background-color': BAR_COLORS[index & BAR_COLORS.length]
          }"
          :title="formatIndicatorTitle(bar.value)"
        />
      </div>

      <div class="grid grid-cols-2 gap-2 col-span-2 items-center">
        <span class="text-xs font-bold">{{ formatIndicatorValue({ indicator: bar.value }) }}</span>
        <span
          v-if="bar.comparison"
          :class="getComparisonClass(bar.comparison)"
          class="font-bold text-xs"
          :title="formatIndicatorTitle(bar.comparison)"
          >{{ formatIndicatorValue({ indicator: bar.comparison, withPlusSign: true }) }}</span
        >
      </div>
    </div>
  </div>
</template>
